/**
 * /inquire のお問い合わせフォーム制御 (Contact Form 7)
 *
 * 旧 Concrete /inquire の挙動を踏襲:
 *   - 送信中は submit ボタンを disabled + ラベル「送信中…」
 *   - 送信成功 (wpcf7mailsent) で /inquire/thanks/ に遷移
 *   - 検証エラー / spam / メール送信失敗時はボタンを元に戻す
 *
 * CF7 はデフォルトで AJAX 送信し、結果に応じて以下のイベントを wrapper (.wpcf7) で発火:
 *   wpcf7invalid / wpcf7spam / wpcf7mailsent / wpcf7mailfailed / wpcf7submit
 * メール送信は WP Mail SMTP (Google Workspace) 経由で行われる。
 */

const THANKS_URL = "/inquire/thanks/";
// generate_lead のタグ送信を待つ上限 (ms)
const GTM_EVENT_TIMEOUT = 2000;

export function initInquireForm() {
  const forms = document.querySelectorAll(".page-inquire .wpcf7-form");
  forms.forEach((form) => {
    const submit = form.querySelector('input[type="submit"], button[type="submit"]');
    if (!submit) return;

    const isInput = submit.tagName === "INPUT";
    const originalLabel = isInput ? submit.value : submit.textContent;

    const setLabel = (text) => {
      if (isInput) submit.value = text;
      else submit.textContent = text;
    };

    const setSending = (sending) => {
      submit.disabled = sending;
      submit.classList.toggle("is-sending", sending);
      setLabel(sending ? "送信中…" : originalLabel);
    };

    // 送信開始: ボタンを送信中状態に。CF7 の AJAX は submit イベントの後に走る。
    form.addEventListener("submit", () => setSending(true));

    const wrapper = form.closest(".wpcf7");
    if (!wrapper) return;

    // 成功: generate_lead (GTM のカスタムイベントトリガーで拾う) を発行し、
    // そのイベントで動くタグの送信完了 (eventCallback) を待ってから thanks ページへ遷移する。
    // 直後に遷移すると Yahoo 広告 (ytag) など sendBeacon を使わないタグが打ち切られるため。
    wrapper.addEventListener("wpcf7mailsent", () => {
      let done = false;
      const goThanks = () => {
        if (done) return;
        done = true;
        window.location.href = THANKS_URL;
      };

      // GTM 未読込・広告ブロック時は eventCallback が呼ばれないので即遷移。保険タイマーでも必ず遷移させる
      if (!window.dataLayer || !window.google_tag_manager) {
        goThanks();
        return;
      }
      window.dataLayer.push({
        event: "generate_lead",
        eventCallback: goThanks,
        eventTimeout: GTM_EVENT_TIMEOUT,
      });
      setTimeout(goThanks, GTM_EVENT_TIMEOUT + 500);
    });

    // 失敗系: ボタンを戻す
    ["wpcf7invalid", "wpcf7spam", "wpcf7mailfailed"].forEach((evt) => {
      wrapper.addEventListener(evt, () => setSending(false));
    });
  });
}
